import TextView from "./TextView";
import AppBtn from "./AppBtn";
import InputField from "./InputField";
import SolidDivider from "./SolidDivider";

const CustomComponent = {
  TextView,
  AppBtn,
  InputField,
  SolidDivider,
};

export default CustomComponent;
